<template>
	<div class="videolist">
		<div class="breadcrumb">付费类型管理</div>
		<div class="searchBtn" style="border:none;display:flex">
			<el-button size='small' type="primary" icon="el-icon-plus" @click="add" plain>添加</el-button>
			<el-button size='small' type="danger" @click="del" plain>删除</el-button>
			<div class="topinput">
				<input type="text" class="el-input__inner" placeholder="付费类型名称">
			</div>
			<div class="topinput">
	    		<input type="text" class="el-input__inner" placeholder="折扣额">
	    	</div>
		    <el-button type="primary" style="margin-left: 15px">搜索</el-button>
	    </div>
	    <el-table
		    ref="multipleTable"
		    :data="tableData3"
		    tooltip-effect="dark"
		    style="width: 100%"
		    >
		    <!-- @selection-change="handleSelectionChange"
		    <el-table-column
		      	type="selection">
		    </el-table-column> -->
		    <el-table-column
		      	prop="vid"
		      	label="序号">
		      	<template slot-scope="scope">{{ scope.row.vid }}</template>
		    </el-table-column>
		    <el-table-column
		      	prop="title"
		      	label="付费标题">
		      	<template slot-scope="scope">{{ scope.row.title }}</template>
		    </el-table-column>
		    
		    <el-table-column
		      	prop="title"
		      	label="付费类型名称">
		      	<template slot-scope="scope">{{ scope.row.title }}</template>
		    </el-table-column>

		    <el-table-column
		      	prop="discount"
		      	label="折扣 % (原价基础上)">
		      	<template slot-scope="scope">{{ scope.row.discount }}</template>
		    </el-table-column>

		    <el-table-column
		      	prop="validtime"
		      	label="有效时间">
		      	<template slot-scope="scope">{{ scope.row.validtime }}</template>
		    </el-table-column>
		    
		    <el-table-column
		      	prop="watchnumber"
		      	label="数量限制">
		      	<template slot-scope="scope">{{ scope.row.watchnumber }}</template>
		    </el-table-column>
		    <el-table-column
		      	label="操作">
		      	<template slot-scope="scope">
		      		<el-button type="text" size="small">修改</el-button>
		      		<el-button type="text" size="small">删除</el-button>
		      	</template>
		    </el-table-column>
		</el-table>
	  	<div style="margin-top: 20px">
	    	<!-- <el-button @click="toggleSelection()">取消选择</el-button> -->
	    	<div style="float:right">
			    <el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
			</div>
		</div>
		<!-- 请选择用户 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" status-icon label-width="120px">
		        <el-form-item label="付费标题" >
				    <el-input v-model="ruleForm.name" placeholder="请输入付费标题"></el-input>
			  	</el-form-item>

		        <el-form-item label="付费类型" >
				    <el-select  placeholder="请选择付费类型" style="width: 100%;" v-model="ruleForm.val1">
				      	<el-option label="包年/包月" value="shanghai"></el-option>
				      	<el-option label="按次" value="beijing"></el-option>
				    </el-select>
			  	</el-form-item>

			  	<el-form-item label="折扣" >
				    <el-select  placeholder="请选择折扣" style="width: 100%;" v-model="ruleForm.val2">
				      	<el-option label="100" value="shanghai"></el-option>
				      	<el-option label="90" value="beijing"></el-option>
				    </el-select>
			  	</el-form-item>
			  	<el-form-item label="时间管理" >
				    <el-button type="primary" style="margin-bottom:20px" @click="addLine">添加行</el-button>
		        	<el-button type="danger"  @click="delLine">删除行</el-button>
		        	<el-table :data="ruleForm.tableData" style="width: 100%" border class="paytab" v-if="ruleForm.tableData.length>0">
				      	<el-table-column prop="date" label="有效时间" >
				      		<template slot-scope="scope">
					      		<el-checkbox label="无限" name="type" style="margin-right:10px"></el-checkbox>
					            <el-date-picker
					                v-model="scope.row.date"
					                type="daterange"
					                range-separator="至"
					                start-placeholder="开始日期"
					                end-placeholder="结束日期">
					            </el-date-picker>
				            </template>
				      	</el-table-column>
				      	<el-table-column prop="nums" label="数量限制" width='110'>
				      		<template slot-scope="scope">
				      			<el-input v-model="scope.row.nums" ></el-input>
				      		</template>
				      	</el-table-column>
				    </el-table>
			  	</el-form-item>
	        
      		</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit()">确 定</el-button>
		    </span>
    	</el-dialog>

	</div>
</template>
<script>
export default {
	components: {},
  	mounted() {

  	},
  	data() {
    	return {
    		paramvideo:{
    			pageNum: 1,
        		limit: 20
    		},//选择教练参数配置
    		pageNum: 1,
		    limit: 5,
		    totalPage: 10,
	      	headers: {
	        	xqiao_token: localStorage.getItem("token")
	      	},
	      	tmpFiles: process.env.API_ROOT + "/tmpFiles",
	      	tableData3: [{
	          	vid: '11',
	          	discount: '0',
	          	validtime: '2016.06.01-2020.08.01',
	          	title:'包年/包月',
	          	cover:'https://image.xqiaotv.com/coach/avatar/153_1571496223222.png',
	          	tag:"标签1",
	          	releasetime:'2019-10-25 17:06:33',
	          	watchnumber:1233,
	          	likenumber:4579,
	          	comments:134,
	          	sharenumber:2345
	        }, {
	          	vid: '22',
	          	discount: '100',
	          	validtime: '无限',
	          	title:'按次',
	          	cover:'https://image.xqiaotv.com/coach/avatar/153_1571496223222.png',
	          	tag:"标签",
	          	releasetime:'2019-11-25 17:06:33',
	          	watchnumber:1235,
	          	likenumber:4578,
	          	comments:134,
	          	sharenumber:2345
	        }, {
	          	vid: '33',
	          	discount: '12',
	          	validtime: '3',
	          	title:'标题',
	          	cover:'https://image.xqiaotv.com/coach/avatar/153_1571496223222.png',
	          	tag:"标签",
	          	releasetime:'2019-11-25 17:06:33',
	          	watchnumber:1233,
	          	likenumber:4578,
	          	comments:134,
	          	sharenumber:2345
	        }, {
	          	vid: '44',
	          	discount: '王小虎',
	          	validtime: '4',
	          	title:'标题',
	          	cover:'https://image.xqiaotv.com/coach/avatar/153_1571496223222.png',
	          	tag:"标签",
	          	releasetime:'2019-11-25 17:06:33',
	          	watchnumber:1233,
	          	likenumber:4578,
	          	comments:134,
	          	sharenumber:2345
	        }, {
	          	vid: '55',
	          	discount: '王小虎',
	          	validtime: '5',
	          	title:'标题',
	          	cover:'https://image.xqiaotv.com/coach/avatar/153_1571496223222.png',
	          	tag:"标签",
	          	releasetime:'2019-11-25 17:06:33',
	          	watchnumber:1233,
	          	likenumber:4578,
	          	comments:134,
	          	sharenumber:2345
	        }, {
	          	vid: '66',
	          	discount: '王小虎',
	          	validtime: '6',
	          	title:'标题',
	          	cover:'https://image.xqiaotv.com/coach/avatar/153_1571496223222.png',
	          	tag:"标签",
	          	releasetime:'2019-11-25 17:06:33',
	          	watchnumber:1233,
	          	likenumber:4578,
	          	comments:134,
	          	sharenumber:2345
	        }, {
	          	vid: '77',
	          	discount: '王小虎',
	          	validtime: '7',
	          	title:'标题',
	          	cover:'https://image.xqiaotv.com/coach/avatar/153_1571496223222.png',
	          	tag:"标签",
	          	releasetime:'2019-11-25 17:06:33',
	          	watchnumber:1233,
	          	likenumber:4578,
	          	comments:134,
	          	sharenumber:2345
	        }],
	        multipleSelection: [],
	        dialogVisible: false,
	        ruleForm: {
		        val1:'',
		        val2:'',
			    tableData: []
		    },
		    ruleForms: {
		        name: [{ required: true, message: "请输入播客名" }],
		        title: [{ required: true, message: "请输入标题" }]
		    }
	    };
  	},
  	methods:{
  		//添加
	    add() {
	    	//this.$router.push({ path: "/editpay" });
	      	if (this.$refs["ruleForm"]) {
	        	this.$refs["ruleForm"].resetFields();
	      	}
	      	this.dialogVisible = true;
	    },
	    //弹框关闭按钮
	    handleClose(done) {
	    	this.dialogVisible = false;
	      	// if (this.$refs.ruleForm != undefined) {
	       //  	this.$refs.ruleForm.resetFields();
	       //  	this.ruleForm={
			        
		      // 	}
	      	// }
	      	// done();
	    },
  		del(){

  		},
  		topnav(e){
 			this.cur=e;
 		},
 		toggleSelection(rows) {
	        if (rows) {
	          rows.forEach(row => {
	            this.$refs.multipleTable.toggleRowSelection(row);
	          });
	        } else {
	          this.$refs.multipleTable.clearSelection();
	        }
	    },
	    handleSelectionChange(val) {
	        this.multipleSelection = val;
	        console.log(val)
	    },
	    //当前页数
	    handleCurrentChangePage(val) {
	    	this.paramvideo.pageNum = val;
	      	//this.getList()
	    },
	    addLine() {
	      	//添加行数
	      	var newValue = {
		        courses:[]
	      	};
	      	//添加新的行数
	      	this.ruleForm.tableData.push(newValue);
	    },
	    delLine() {//删除行数
	    	this.ruleForm.tableData.pop();	
	    },
  	}
}
</script>
<style scoped>
.el-input {
  	width: 80%;
}
.el-textarea__inner {
  	width: 80%;
}
.avatar-uploader {
  	padding-top: 20px;
}
.el-upload {
  	border: 1px dashed #d9d9d9;
  	border-radius: 6px;
  	cursor: pointer;
  	position: relative;
  	overflow: hidden;
}
.el-upload:hover {
  	border-color: #409eff;
}
.avatar-uploader-icon {
  	font-size: 28px;
  	color: #8c939d;
  	width: 178px;
  	height: 178px;
  	line-height: 178px;
  	text-align: center;
}
.avatar {
  	max-width: 100%;
  	max-height: 100%;
  	display: block;
  	margin: 0 auto;
}
.selectUser {
  	color: #409eff;
}
.selectUser label,
.selectUser i {
  	font-size: 12px;
}

.imgWidth{
	width: 50px;
	height: 50px;
	border:1px solid #ccc;
	display:flex;
  	align-items:center;
}
.imgWidth img,.avatar{
	max-width: 100%;
}

::deep
.el-upload{
	width: 178px;
    height: 178px;
    text-align: center;
    display:flex;
  	align-items:center;
}
::deep
.el-date-editor .el-range-separator{
	padding: 0
}
.searchBtn .el-range-editor.el-input__inner{
	margin: 0 15px
}
.topinput{
	margin-left: 15px;
	width: 250px
}
.topinput input{
	font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/views/payList/index.vue